import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { Tooltip } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gc-floating-popup-header-actions',
  standalone: true,
  imports: [CommonModule, ButtonModule, SvgIconComponent, Tooltip, TranslatePipe],
  templateUrl: './floating-popup-header-actions.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupHeaderActionsComponent {
  public readonly service: FloatingPopupService = inject(FloatingPopupService);

  public popup = input.required<IFloatingPopupInstance>();
}
